import { render, staticRenderFns } from "./programPackBookPage.vue?vue&type=template&id=972f0e98&scoped=true&"
import script from "./programPackBookPage.vue?vue&type=script&lang=ts&"
export * from "./programPackBookPage.vue?vue&type=script&lang=ts&"
import style0 from "./programPackBookPage.vue?vue&type=style&index=0&id=972f0e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972f0e98",
  null
  
)

export default component.exports